export const SETQUOTENOLIST = "SETQUOTENOLIST";
export const SETFILTERCUSTOMERLIST = "SETFILTERCUSTOMERLIST";
export const SETSALESQUOTELIST = "SETSALESQUOTELIST";
export const SETSALESQUOTELISTBYID = "SETSALESQUOTELISTBYID";
export const SETPRJLIST = "SETPRJLIST";
export const SETTAXLIST = "SETTAXLIST";
export const SETCOSTCENTERLIST = "SETCOSTCENTERLIST";
export const SETPAYTERMSLIST = "SETPAYTERMSLIST";
export const SETSUPPLYLIST = "SETSUPPLYLIST";
export const SETSALESEMPLIST = "SETSALESEMPLIST";
export const CLEARDOC = "CLEARDOC";
export const SETITEMLIST = "SETITEMLIST";
export const SETITEMS = "SETITEMS";
export const SETCUSTOMERLIST = "SETCUSTOMERLIST";
export const SETCUSTOMERADDRESS = "SETCUSTOMERADDRESS";
export const SETCUSTOMERADDRESSLIST = "SETCUSTOMERADDRESSLIST";
export const SETHSNLIST = "SETHSNLIST";
export const SETSALESQUOTE = "SETSALESQUOTE";
export const SETATTACHMENTLIST = "SETATTACHMENTLIST";
export const SETADVANCEFILTERLIST = "SETADVANCEFILTERLIST";
export const SETITEMINFO = "SETITEMINFO";
export const SETCUSTOMERINFO = "SETCUSTOMERINFO";
export const SETDUPLICATEDOC = "SETDUPLICATEDOC";
export const SETDEFAULTCURRENCY = "SETDEFAULTCURRENCY";
export const SETKITITEM = "SETKITITEM";
export const SETUDFLIST = "SETUDFLIST";
export const SETEMAILCONTENT = "SETEMAILCONTENT";
export const SETFLEXIQUOTEDETAILS = "SETFLEXIQUOTEDETAILS";
export const SETSALESQUOTEBASICFILTERDATA = "SETSALESQUOTEBASICFILTERDATA";
export const SETQUOTECATEGORY = "SETQUOTECATEGORY";
export const SETBPMASTERADDRESS = "SETBPMASTERADDRESS";
export const SETPRICELIST = "SETPRICELIST";
export const SETTAXCODE = "SETTAXCODE";
export const SETSALESQUOTEITEMLISTING = "SETSALESQUOTEITEMLISTING";
export const SETATTACHMENTDATA = "SETATTACHMENTDATA";
export const SETSERIESLIST = "SETSERIESLIST";
export const SETWHSELIST = "SETWHSELIST";
export const SETSTATUSLIST = "SETSTATUSLIST";
export const SETSALESQUOTESTATUSCOUNT = "SETSALESQUOTESTATUSCOUNT";
export const SETCOSTCENTER = "SETCOSTCENTER";
export const SETTERMSANDCONDITION = "SETTERMSANDCONDITION";
